import React from 'react';
import { Modal } from 'antd';
import { useTranslation } from 'react-i18next';
import { ExportLoadingModalStyle } from './ExportLoadingModal.style';

export interface IExportLoadingModalProps {
    open: boolean;
    type: 'excel' | 'pdf';
    progress?: number;
}

export const ExportLoadingModal: React.FC<IExportLoadingModalProps> = ({
    open,
    type,
    progress = 0
}) => {
    const { t } = useTranslation();

    const getExportTypeText = () => {
        return type === 'excel' ? t('general.exporting_excel') : t('general.exporting_pdf');
    };

    const getExportTypeIcon = () => {
        return type === 'excel' ? '📊' : '📄';
    };

    return (
        <ExportLoadingModalStyle
            open={open}
            centered
            closable={false}
            footer={null}
            width={400}
            maskClosable={false}
        >
            <div className="export-loading-container">
                <div className="loading-animation">
                    <div className="spinner">
                        <div className="spinner-inner">
                            <div className="spinner-dot"></div>
                            <div className="spinner-dot"></div>
                            <div className="spinner-dot"></div>
                            <div className="spinner-dot"></div>
                        </div>
                    </div>
                    <div className="pulse-ring"></div>
                </div>

                <div className="export-content">
                    <div className="export-icon">
                        {getExportTypeIcon()}
                    </div>

                    <h3 className="export-title">
                        {getExportTypeText()}
                    </h3>

                    <p className="export-description">
                        {t('general.export_description')}
                    </p>

                    <div className="progress-container">
                        <div className="progress-bar">
                            <div
                                className="progress-fill"
                                style={{ width: `${progress}%` }}
                            ></div>
                        </div>
                        <span className="progress-text">{progress}%</span>
                    </div>

                    <div className="loading-dots">
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>
            </div>
        </ExportLoadingModalStyle>
    );
};

export default ExportLoadingModal;
